import React from "react";
import { FC } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import ButtonSecondary from "shared/Button/ButtonSecondary";
export interface CommonLayoutProps {
  index: string;
  maxIndex?: string;
  nextHref: string;
  backtHref: string;
  nextBtnText?: string;
  children: React.ReactNode;
  onSubmit?: any;
  hideBackButton?: boolean;
  onBack?: () => void;
}
const CommonLayout: FC<CommonLayoutProps> = ({
  index = "01",
  maxIndex = "3",
  children,
  nextHref,
  nextBtnText,
  backtHref,
  onSubmit = null,
  hideBackButton = false,
  onBack = null, 
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const isCreateBrandPage = location.pathname === "/create-brand";
  const showBackButton = !hideBackButton && !isCreateBrandPage;
  
  const handleBackClick = () => {
    if (onBack) {
      onBack();
    } else {
      navigate(backtHref);
    }
  }
  
  return (
    <div
      className={`nc-PageAddListing1 px-4 max-w-3xl mx-auto pb-24 pt-14 sm:py-24 lg:pb-32`}
      data-nc-id="PageAddListing1"
    >
      <div className="space-y-11">
        <div>
          <span className="text-4xl font-semibold">{index}</span>{" "}
          <span className="text-lg text-neutral-500 dark:text-neutral-400">
            / {maxIndex}
          </span>
        </div>

        {/* --------------------- */}
        <div className="listingSection__wrap ">{children}</div>

        {/* --------------------- */}
        <div className="flex justify-end space-x-5">
          {showBackButton && (
              <ButtonSecondary 
                onClick={handleBackClick}
              >
                Go back
              </ButtonSecondary>
            )}
            {onSubmit ? (
              <ButtonPrimary onClick={onSubmit}>
                {nextBtnText || "Continue"}
              </ButtonPrimary>
            ) : (
              <ButtonPrimary href={nextHref}>
                {nextBtnText || "Continue"}
              </ButtonPrimary>
            )
          }
        </div>
      </div>
    </div>
  );
};

export default CommonLayout;
